const LANGUAGE_PREFERENCE_KEY = 'aevdir.lang';
const SUPPORTED_LANGS = ['en', 'zh'];

function normalizeLang(value) {
  if (!value) return null;
  const normalized = String(value).trim().toLowerCase();
  return SUPPORTED_LANGS.includes(normalized) ? normalized : null;
}

export function getStoredLanguagePreference() {
  if (typeof window === 'undefined') return null;
  return normalizeLang(window.localStorage.getItem(LANGUAGE_PREFERENCE_KEY));
}

export function setStoredLanguagePreference(lang) {
  const normalized = normalizeLang(lang);
  if (typeof window === 'undefined' || !normalized) return;
  window.localStorage.setItem(LANGUAGE_PREFERENCE_KEY, normalized);
}

function isChinaLocation(countryCode, countryName) {
  const code = String(countryCode || '').trim().toUpperCase();
  if (code === 'CN') return true;
  const name = String(countryName || '').trim().toLowerCase();
  return name.includes('china') || name.includes('中国');
}

async function fetchGeoLang(url, parser) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }
  const payload = await response.json();
  const { countryCode, countryName } = parser(payload);
  return isChinaLocation(countryCode, countryName) ? 'zh' : 'en';
}

export async function detectLanguageByGeo() {
  const detectors = [
    () =>
      fetchGeoLang('https://ipapi.co/json/', (payload) => ({
        countryCode: payload?.country_code,
        countryName: payload?.country_name,
      })),
    () =>
      fetchGeoLang('https://ipwho.is/', (payload) => ({
        countryCode: payload?.country_code,
        countryName: payload?.country,
      })),
  ];

  for (const detect of detectors) {
    try {
      // Try next provider when current one fails.
      // eslint-disable-next-line no-await-in-loop
      const lang = await detect();
      if (lang) return lang;
    } catch (_) {
      // Ignore provider errors and continue fallback chain.
    }
  }

  return 'en';
}
